import React, {useMemo} from 'react'
import useOuterLabelPlugin from './OuterLabelPlugin'
import {cloneDeep} from 'lodash'

import './donutChart.scss'
import PropTypes from 'prop-types'
import ChartComponent from "../Chart/ChartComponent";

import {ArcElement, Chart, DoughnutController} from 'chart.js'

Chart.register(DoughnutController, ArcElement);

/** Donut chart  */
const DonutChart = ({data, className, id, centerText, chartProps, chartOptionsProps}) => {
  const sortedData = useMemo(() => biggestToMiddle(data), data)
  return <div className={`Suc-donut-chart ${className}`}>
    <div className={'Suc-donut-wrapper'}>
      <ChartComponent
        type='doughnut'
        id={id}
        plugins={[useOuterLabelPlugin()]}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          cutout: '85%',
          animation: {animateRotate: false},
          plugins: {
            labels: {
              render: ({index, dataset, value}) => {
                const unit = dataset?.unit[index] || ''
                return [{text: `${dataset?.valueLabel[index] || value} ${unit}`}]
              },
              position: 'outside',
              textMargin: 5,
              fontColor: ({backgroundColor}) => backgroundColor,
              fontSize: 15
            },
            legend: {display: false},
            tooltip: {enabled: false},
          },
          layout: {
            padding: {
              top: 30,
              bottom: 30
            }
          },
          ...chartOptionsProps
        }}
        data={{
          labels: sortedData.map(item => item.label),
          datasets: [{
            data: sortedData.map(item => item.value),
            backgroundColor: sortedData.map(item => item.color),
            unit: sortedData.map(item => item.unit),
            valueLabel: sortedData.map(item => item.valueLabel)
          }]
        }
        } {...chartProps} />
      <div className={'Suc-center-text'}>{centerText}</div>
    </div>
    <div className={'Suc-custom-legends'}>
      {data.map(item => <div key={item.label} className={`Suc-custom-legend ${item.label}`} data-for-testimio={item.value}>
        <div className={'Suc-color-box'} style={{backgroundColor: item.color}}/>
        <div className={'Suc-legend-label'}>{item.label}</div>
      </div>)}
    </div>
  </div>
}

export default DonutChart

/** This function takes and array and put the biggest number in the middle, on radical data scenarios it prevents value label to overlap  */
const biggestToMiddle = (data) => {
  const arr = cloneDeep(data)
  arr.sort(function (a, b) {
    return a.value - b.value
  })
  const arr1 = arr.slice(0, arr?.length / 2)
  const arr2 = arr.slice(arr?.length / 2, arr?.length)
  arr2.sort(function (a, b) {
    return b.value - a.value
  })
  return arr1.concat(arr2)
}

const dataShape = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  unit: PropTypes.string,
  valueLabel: PropTypes.string
}
DonutChart.propTypes = {
  /** Data for donut */
  data: PropTypes.arrayOf(PropTypes.shape(dataShape)),
  /** Text or JSX that goes in the middle of the chart */
  centerText: PropTypes.node,
  /** Id - helps to fetch the data with testimIO
   const chart = Object.values(Chart.instances).find(({canvas})=>canvas.id==='[donut-id]')
   console.log(chart.config.data.datasets[0].data)
   */
  id: PropTypes.string,
  className: PropTypes.string,
  /** override chart.js props */
  chartProps: PropTypes.object,
  /** override chart.js options */
  chartOptionsProps: PropTypes.object
}

DonutChart.defaultProps = {
  className: '',
  id: null
}
